import { render, staticRenderFns } from "./cardVisitPro.vue?vue&type=template&id=4b865877&scoped=true"
import script from "./cardVisitPro.vue?vue&type=script&lang=js"
export * from "./cardVisitPro.vue?vue&type=script&lang=js"
import style0 from "./cardVisitPro.vue?vue&type=style&index=0&id=4b865877&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b865877",
  null
  
)

export default component.exports